<template>
  <div class="container">
<!--    pc-->
    <div class="jumpPc" v-if="!isMobile">
      <sys-dialog
        v-show="dialogVisible"
        :show-close="showCloseBtn"
        :close-image="closeBtnImg"
        :error-msg="errorMsg"
        @close="closeDialog"
      />
      <sys-loading :loading="loading" />
      <div class="logo-area">
        <img alt src="../assets/logo.png" />
        <img alt src="../assets/jump/title.png" />
      </div>
      <div class="swiper-content">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="index in 4" :key="index">
            <img :src="require(`../assets/jump/swiper/swiper-${index}.jpg`)" alt="" width="100%" />
          </swiper-slide>
        </swiper>
        <div class="prev-btn nav-btn" slot="button-prev"></div>
        <div class="next-btn nav-btn" slot="button-next"></div>
      </div>
      <div class="form-content">
        <div class="form">
          <div class="tags">
            <span :class="isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = true">
              ĐĂNG KÝ
            </span>
            <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = false">
              ĐĂNG NHẬP
            </span>
          </div>
          <div class="inputs" :style="isRegisterAction ? '' : 'height: 270PX;'">
            <div class="form-input">
              <img src="../assets/jump/icon-username.png"  alt="img"/>
              <input v-model="form.username" placeholder="Nhập tên đăng nhập *" style="--size:12em;"
                     oninput="value=value.replace(/[\W]/g,'')"
                     maxlength="20" autocomplete="off" @blur="onblur('username')"/>
            </div>
            <span class="tips">{{ tipsObj.userTips }}</span>
            <div class="form-input">
              <img src="../assets/jump/icon-password.png"  alt="img"/>
              <input v-model="form.password" :type="showPwd ? 'password' : 'text'" autocomplete="new-password"
                     maxlength="15"
                     placeholder="Nhập mật khẩu *" style="--size:10em;" @blur="onblur('password')">
              <img :src="require(`../assets/jump/eye-${showPwd ? 'close':'open'}.png`)" alt @click="showPwd=!showPwd">
            </div>
            <span class="tips">{{ tipsObj.passTips }}</span>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/jump/icon-password.png"  alt="img"/>
              <input v-model="form.rePassword" :type="showRePwd ? 'password' : 'text'" autocomplete="new-password"
                     maxlength="15"
                     placeholder="Xác nhận mật khẩu *" style="--size:12em;" @blur="onblur('rePassword')"/>
              <img :src="require(`../assets/jump/eye-${showRePwd ? 'close':'open'}.png`)" alt @click="showRePwd=!showRePwd">
            </div>
            <span class="tips" v-show="isRegisterAction">{{ tipsObj.rePassTips }}</span>

<!--            <div class="form-input" v-show="isRegisterAction">-->
<!--              <img src="../assets/jump/icon-phone.png"  alt="img"/>-->
<!--              <input v-model="form.phone" autocomplete="new-password"-->
<!--                     oninput="value=value.replace(/^\D/, '')"  maxlength="10"-->
<!--                     placeholder="Nhập số điện thoại *" style="&#45;&#45;size:12em;" @blur="onblur('phone')"/>-->
<!--            </div>-->
<!--            <span class="tips" v-show="isRegisterAction">{{ tipsObj.phoneTips }}</span>-->

            <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;">
              <img src="../assets/jump/icon-code.png" style="width: 35px;height: 24px;" alt="img"/>
              <input v-model="form.verificationCode" autocomplete="off" placeholder="Nhập mã xác minh *" maxlength="4" style="--size:11.5em;" @blur="onblur('code')"/>
              <img class="codeImg" v-show="captchaImg" :src="captchaImg" @click="getCode" alt="code" style="width: 120px;">
            </div>
            <span class="tips" v-show="isRegisterAction">{{ tipsObj.codeTips }}</span>
            <v-captcha
              ref="vcaptcha1"
              :dialogVisible="dialogVisible"
              :showCheck="showCheck"
              @cb="handleConfirm"
              :vstyle="{ bottom: '30px', position: 'absolute' }"
              :nativeButton="{
                width: '250px',
                height: '70px'
              }"
            >
              <div
                v-show="isRegisterAction"
                class="submitBtn"
                @click="submitAction(1)"
              >
                ĐĂNG KÝ
              </div>
            </v-captcha>

            <div
              v-show="!isRegisterAction"
              class="submitBtn"
              @click="submitAction(2)"
            >
              ĐĂNG NHẬP
            </div>
          </div>
        </div>
        <sys-contact :is-h5="false" class="customer"/>
      </div>
    </div>
    <div class="jumpRoot" v-else>
      <sys-dialog
        v-show="dialogVisible"
        :show-close="true"
        :close-image="closeBtnImg"
        :error-msg="errorMsg"
        @close="closeDialog"
      />
      <sys-loading :loading="loading" />
      <img class="logo" alt src="../assets/logo.png" />
      <img class="title" alt src="../assets/jump/title.png" />
      <div class="swiper-content">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="index in 4" :key="index">
            <img :src="require(`../assets/jump/swiper/swiper-${index}.jpg`)" alt="" width="100%" />
          </swiper-slide>
        </swiper>
        <div class="prev-btn nav-btn" slot="button-prev"></div>
        <div class="next-btn nav-btn" slot="button-next"></div>
      </div>
      <div class="form-content">
        <div class="tags">
          <span
            :class="isRegisterAction ? 'tag active' : 'tag'"
            @click="isRegisterAction = true"
            >ĐĂNG KÝ</span>
          <span
            :class="!isRegisterAction ? 'tag active' : 'tag'"
            @click="isRegisterAction = false"
            >ĐĂNG NHẬP</span
          >
        </div>
        <div class="inputs">
          <div class="form-input">
            <img src="../assets/jump/icon-username.png" />
            <input v-model="form.username"
                   placeholder="Nhập tên đăng nhập *" style="--size: 11.5em"
                   oninput="value=value.replace(/[\W]/g,'')"
                   maxlength="20"
                   autocomplete="off" @blur="onblur('username')"
            />
          </div>
          <span class="tips">{{ tipsObj.userTips }}</span>

          <div class="form-input">
            <img src="../assets/jump/icon-password.png" />
            <input
              v-model="form.password"
              :type="showPwd ? 'password' : 'text'"
              placeholder="Nhập mật khẩu *"
              style="--size: 9.5em"
              maxlength="15"
              @blur="onblur('password')"
            />
            <img :src="require(`../assets/jump/eye-${showPwd ? 'close':'open'}.png`)" alt @click="showPwd=!showPwd">
          </div>
          <span class="tips">{{ tipsObj.passTips }}</span>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/jump/icon-password.png" />
            <input
              v-model="form.rePassword"
              :type="showRePwd ? 'password' : 'text'"
              style="--size: 11em"
              autocomplete="new-password"
              placeholder="Xác nhận mật khẩu *"
              maxlength="15"
              @blur="onblur('rePassword')"
            />
            <img :src="require(`../assets/jump/eye-${showRePwd ? 'close':'open'}.png`)" alt @click="showRePwd=!showRePwd">
          </div>
          <span class="tips" v-show="isRegisterAction">{{ tipsObj.rePassTips }}</span>

<!--          <div class="form-input">-->
<!--            <img src="../assets/jump/icon-phone.png" />-->
<!--            <input v-model="form.phone"-->
<!--                   placeholder="Nhập số điện thoại *" style="&#45;&#45;size: 11.5em"-->
<!--                   maxlength="10" oninput="value=value.replace(/^\D/, '')"-->
<!--                   autocomplete="off" @blur="onblur('phone')"-->
<!--            />-->
<!--          </div>-->
<!--          <span class="tips">{{ tipsObj.phoneTips }}</span>-->

          <div
            class="form-input"
            v-show="isRegisterAction"
            style="margin-bottom: 0;"
          >
            <img src="../assets/jump/icon-code.png" />
            <input
              v-model="form.verificationCode"
              autocomplete="off"
              placeholder="Nhập mã xác minh *"
              style="--size: 11em"
              maxlength="4"
              @blur="onblur('code')"
            />
            <img class="codeImg" v-show="captchaImg" :src="captchaImg" @click="getCode" alt="code">
          </div>
          <span class="tips" v-show="isRegisterAction">{{ tipsObj.codeTips }}</span>
<!--          <a v-if="!isRegisterAction" class="error" href="https://www.2q.com"-->
<!--            >Quên Mật Khẩu?</a-->
<!--          >-->
          <v-captcha
            ref="vcaptcha1"
            :dialogVisible="dialogVisible"
            :showCheck="showCheck"
            @cb="handleConfirm"
            :vstyle="{ bottom: '2vh', position: 'absolute' }"
            :nativeButton="{
              width: '43.7333vw',
              height: '7.6461vh'
            }"
          >
            <div
              class="submitBtn"
              v-show="isRegisterAction"
              @click="submitAction(1)"
            >
              ĐĂNG KÝ
            </div>
          </v-captcha>
          <div
            v-show="!isRegisterAction"
            class="submitBtn"
            @click="submitAction(2)"
          >
            ĐĂNG NHẬP
          </div>
        </div>
      </div>
      <sys-contact :is-h5="true" class="customer"/>
    </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import md5 from "js-md5";
import {DOMAIN_INVITE_CODE, FORM_VALID_MESSAGE} from "../utils/constant";
import {getCapCode, userLogin, userRegister} from "../utils/request";
import {encodePlatformUrl, isMobile, validForm} from "../utils/tools";
import {captcha} from "@/mixins/captcha";
import {validCode, validNameTips, validPassword, validPhone, validRePassword} from "../utils/util";

export default {
  name: "Jump",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {

      showPwd:true,
      showRePwd:true,

      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,
      closeBtnImg: require("../assets/jump/icon-close.png"),
      form: {
        by: 1,
        username: "",
        userName: "",
        phone: "",
        password: "",
        rePassword: "",
        verificationCode: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      swiperOptions: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      },
      tipsObj: {
        userTips:'',
        passTips:'',
        rePassTips:'',
        codeTips:'',
        phoneTips:''
      },
      captchaImg: '',
      showCloseBtn: false
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
    this.getCode();
  },
  methods: {
    onblur(type){
      console.log('我日。。你怎么这样。。。', type)
      if (type === 'username'){
        this.tipsObj.userTips = validNameTips(this.form.username);
      }
      if (type === 'password'){
        this.tipsObj.passTips = validPassword(this.form.password)
      }
      if (type === 'rePassword'){
        this.tipsObj.rePassTips = validRePassword(this.form.password,this.form.rePassword);
      }
      if (type === 'code'){
        this.tipsObj.codeTips = validCode(this.form.verificationCode);
      }
      if (type === 'phone') {
        this.tipsObj.phoneTips = validPhone(this.form.phone)
      }
    },
    getCode() {
      getCapCode().then(res=>{
        if (!res.body.code){
          this.captchaImg = res.body.data
        }
      })
        .catch(err=>{
          console.log(err)
        })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        if (temp.username && temp.password){
          let params = {
            acctType: 6,
            by: 1,
            // email: temp.email,
            userName: temp.username,
            // phone: temp.phone,
            password: md5(temp.password)
          };
          this.login(params);
        } else {
          this.setDialogMsg(
            FORM_VALID_MESSAGE.registerFailTitle,
            FORM_VALID_MESSAGE.wrongMsg
          );
          this.loading = false;
        }
      } else {
        this.form.inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg,
              false
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      const isAll = params.username && params.password && params.rePassword && params.verificationCode
      const isSame = params.password === params.rePassword
      if (isAll && isSame){
        this.handleConfirm()
      } else {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.wrongMsg
        );
        this.loading = false;
      }
      // if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
      //   this.setDialogMsg(
      //     FORM_VALID_MESSAGE.registerFailTitle,
      //     FORM_VALID_MESSAGE.passwordMsg
      //   );
      //   this.loading = false;
      //   return;
      // }
      // this.handleCheck(this.handleConfirm);

    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg,
              false
            );
            // createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
            this.getCode()
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
          this.getCode()
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg,showClose=true) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
      this.showCloseBtn = showClose
    }
  }
};
</script>

<style lang="less" scoped>
@plugin "../utils/plugin";
@base: 1PX;

.jumpPc {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/jump/bgi-pc.jpg");
  background-size: 100% 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13%;

  .logo-area {
    position: fixed;
    top: px(20);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-content {
    width: px(543);
    margin-top: @base * 150;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .form {
      width: 100%;

      .tags {
        width: 100%;
        height: 68PX;
        position: relative;
        top: 30PX;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: "Montserrat";
        font-size: 20PX;
        color: #ffffff;

        .tag {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          cursor: pointer;
          position: relative;
          font-size: 22PX;
          font-weight: 800;
          color: #000000;
          text-shadow:0 0 4PX #fff;
          white-space: nowrap;


          &:nth-child(1) {
            background-image: url("../assets/jump/bgi-tag-left.png");
            width: 198PX;
            background-size: 100% 100%;

            &.active {
              background-image: url("../assets/jump/bgi-tag-left-active.png");
              width: 346PX;
              font-size: 32PX;
            }
          }

          &:nth-child(2) {
            background-image: url("../assets/jump/bgi-tag-right.png");
            width: 197PX;
            background-size: 100% 100%;

            &.active {
              background-image: url("../assets/jump/bgi-tag-right-active.png");
              width: 347PX;
              font-size: 32PX;
            }
          }
        }
      }

      .inputs {
        height: 490PX;
        width: 100%;
        background-image: url("../assets/jump/bgi-form.png");
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-top: 60PX;
        position: relative;
      }

      .form-input {
        width: 88%;
        height: 50PX;
        position: relative;

        img {
          width: 30PX;
          height: 30PX;
          position: absolute;
          top: calc(50% - 15PX);
          &:first-child{
            left: 20PX;
          }
          &:last-child{
            right: 20PX;
            cursor: pointer;
          }
        }

        input {
          width: 100%;
          height: 100%;
          background: white;
          border-radius: 50PX;
          border: none;
          outline: none;
          text-indent: 60PX;
          font-weight: 500;
          font-size: 20PX;
          color: #5A5A5A;
          &::placeholder{
            font-size: 20PX;
            font-style: 1em;
            background: linear-gradient(to right, rgba(90, 90, 90, 0.45) 0, rgba(90, 90, 90, 0.45) var(--size), #35C0FF var(--size));
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }
      .tips {
        height: 24PX;
        width: 80%;
        font-size: 20PX;
        font-weight: 500;
        color: white;
        display: flex;
        padding-left: 45PX;
        padding-bottom: 5PX;
      }

      a.error {
        display: block;
        margin: 20PX;
        color: #ffffff;
        font-size: 20PX;
        text-decoration: none;
      }

      .submitBtn {
        width: 301PX;
        height: 103PX;
        background-image: url("../assets/jump/bgi-btn.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Black;
        font-size: 28PX;
        color: #ffffff;
        cursor: pointer;
        position: absolute;
        bottom: -42PX;
      }
    }
    .customer {
      position: absolute;
      bottom: px(-105);
    }
  }

  .swiper-content {
    width: 560PX;
    height: 560PX;
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 250PX;

    .next-btn {
      right: -60PX;
      width: 28PX;
      height: 53PX;
      background-image: url("../assets/jump/swiper-left.png");
    }

    .prev-btn {
      left: -60PX;
      width: 28PX;
      height: 53PX;
      transform: scaleX(-1);
      background-image: url("../assets/jump/swiper-left.png");
    }

    .nav-btn {
      position: absolute;
      top: calc(50% - 33.5PX);
    }
  }

  /deep/ .mask-layer .modal .close-img {
    top: -32PX;
    right: -32PX;
    position: absolute;
    cursor: pointer;
  }
}


.jumpRoot {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  background-image: url("../assets/jump/bgi-h5.jpg");
  background-size: 100% 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
  color: #ffffff;

  ::-ms-input-placeholder {
    font-size: 1.2em;
  }

  ::-webkit-input-placeholder {
    font-size: 1.2em;
  }

  img.logo {
    margin: 15px 0;
    height: 102px;
  }

  img.title {
    width: 90%;
    margin-bottom: 11px;
  }

  .swiper-content {
    width: 380px;
    height: 380px;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .next-btn {
      right: -60px;
      width: 20px;
      height: 36px;
      background-image: url("../assets/jump/swiper-left.png");
      background-size: 100% 100%;
    }

    .prev-btn {
      left: -60px;
      width: 20px;
      height: 36px;
      transform: scaleX(-1);
      background-image: url("../assets/jump/swiper-left.png");
      background-size: 100% 100%;
    }

    .nav-btn {
      position: absolute;
      top: calc(50% - 33.5px);
    }
  }

  .form-content {
    width: 543px;
    display: flex;
    flex-flow: column;
    align-items: center;

    .tags {
      width: 100%;
      height: 80px;
      font-family: "Montserrat-Black";
      font-size: 24px;
      color: #ffffff;
      z-index: 1;
      display: flex;
      align-items: center;

      .tag {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000000;
        text-shadow:0 0 4px #fff;
        white-space: nowrap;
        opacity:0.5;

        &:nth-child(1) {
          background-image: url("../assets/jump/bgi-tag-left.png");
          background-size: 100% 100%;
          width: 198px;
          height: 68px;

          &.active {
            background-image: url("../assets/jump/bgi-tag-left-active.png");
            background-size: 100% 100%;
            width: 346px;
            height: 68px;
            opacity: 1;
            text-shadow:0 0 4px white;
          }
        }

        &:nth-child(2) {
          background-image: url("../assets/jump/bgi-tag-right.png");
          background-size: 100% 100%;
          width: 197px;
          height: 68px;

          &.active {
            background-image: url("../assets/jump/bgi-tag-right-active.png");
            width: 347px;
            height: 68px;
            opacity: 1;
            text-shadow:0 0 4px #fff;
          }
        }
      }
    }

    .inputs {
      width: 100%;
      background-image: url("../assets/jump/bgi-form.png");
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      top: -33px;
      padding-top: 58px;
      padding-bottom: 86px;

      .form-input {
        width: 468px;
        height: 50px;
        position: relative;
        display: flex;

        img {
          width: 25px;
          height: 25px;
          position: absolute;
          top: calc(50% - 12.5px);
          left: 16.5px;
          &:last-child{
            right: 20px;
            left: auto;
          }
        }

        input {
          width: 100%;
          height: 100%;
          background: white;
          border-radius: 50px;
          border: none;
          outline: none;
          text-indent: 57px;
          font-weight: 500;
          font-size: 20px;
          color: #5A5A5A;
          &::placeholder{
            font-style: 1em;
            background: linear-gradient(to right, rgba(90, 90, 90, 0.45) 0, rgba(90, 90, 90, 0.45) var(--size), #35C0FF var(--size));
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
        }
        .codeImg{
          width: 120px;
          position: absolute;
          right: 30px;
          left: auto;
        }
      }

      .tips {
        height: 36px;
        width: 80%;
        font-size: 20px;
        font-weight: 500;
        color: white;
        display: flex;
        padding-left: 45px;
        padding-top: 10px;
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
      }

      .submitBtn {
        width: 300px;
        height: 103px;
        background-image: url("../assets/jump/bgi-btn.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Black;
        font-size: 28px;
        font-weight: 800;
        color: #ffffff;
        position: absolute;
        bottom: -45px;
      }
    }
  }
  .customer {
    position: fixed;
    right: 30px;
    bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Football.vue